import N8nActionBox from './ActionBox.vue';

export default N8nActionBox;
